function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import isEqual from 'lodash/isEqual';
import { tokens } from '@domain-group/fe-brary';
var spacingUnit = tokens.spacing.xxs;
export var arrayify = value => Array.isArray(value) ? value : [value];
var isSizeClassedObject = item => typeof item === 'object' && !!item && Object.keys(item).some(key => ['compact', 'regular', 'large'].includes(key));
export var shallowToBreakpointed = props => Object.fromEntries(Object.entries(props).map(_ref => {
  var _propValue$regular, _ref3, _propValue$large;
  var _ref2 = _slicedToArray(_ref, 2),
    prop = _ref2[0],
    propValue = _ref2[1];
  return [prop, isSizeClassedObject(propValue) ? {
    compact: propValue.compact,
    regular: (_propValue$regular = propValue.regular) !== null && _propValue$regular !== void 0 ? _propValue$regular : propValue.compact,
    large: (_ref3 = (_propValue$large = propValue.large) !== null && _propValue$large !== void 0 ? _propValue$large : propValue.regular) !== null && _ref3 !== void 0 ? _ref3 : propValue.compact
  } : {
    compact: propValue,
    regular: propValue,
    large: propValue
  }];
}));
export var reduceStyles = styles => styles.reduce((prev, cur) => {
  if (!prev.length) {
    return [cur];
  }
  var findPreviousDefinedValue = key => [...prev].reverse().reduce((found, val) => found || val[key], undefined);
  var filtered = Object.fromEntries(Object.entries(cur).filter(_ref4 => {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      val = _ref5[1];
    return !isEqual(findPreviousDefinedValue(key), val);
  }));
  return [...prev, filtered];
}, []);
export var resolveSpacingUnit = input => typeof input === 'string' ? tokens.spacing[input] : "calc(".concat(input, " * ").concat(spacingUnit, ")");
export var basis = (gapSize, itemCount) => "calc(100%/".concat(itemCount, " - ").concat(tokens.spacing[gapSize], " * ").concat(itemCount - 1, ")");